/* src/app/order/components/additional-questions/additional-questions.style.scss */
.product-additional-questions {
  margin-bottom: 40px;
}
.product-header {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  margin: 20px 0 10px 0;
}
.product-header h6 {
  font-family: Arial, sans-serif;
  font-size: 18px;
  font-weight: bold;
  line-height: 1.33;
  color: #007d40;
  margin-top: 0;
  margin-bottom: 0;
}
.product-header .toggle-view-section {
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  text-align: center;
  color: #007d40;
  cursor: pointer;
  text-decoration: none;
}
.product-header .toggle-view-section nb-icon {
  position: relative;
  top: 2px;
}
.product-header.with-copy-button {
  margin-bottom: 17px;
}
.product-header copy-button {
  position: relative;
  top: 10px;
}
.hide-section {
  display: none;
}
/*# sourceMappingURL=additional-questions.style.css.map */
